require('../../modules/es.typed-array.int32-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Int32Array;
